import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackOnOpen = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);

    trackProductAnalytics('Clicked');
  }, [productEvents]);

  return trackCallback;
};

export default useTrackOnOpen;
